import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmail } from '../../api/SupabaseApi';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await signInWithEmail(email, password);
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <form onSubmit={handleSubmit} className="bg-surface p-8 rounded-xl shadow-lg w-full max-w-md border border-border">
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
        {error && <div className="mb-4 text-error text-sm text-center">{error}</div>}
        <div className="mb-4">
          <label className="block mb-1 text-text-primary">Email</label>
          <input
            type="email"
            className="w-full px-3 py-2 border border-border rounded-lg bg-background text-text-primary"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-6">
          <label className="block mb-1 text-text-primary">Password</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              className="w-full px-3 py-2 pr-10 border border-border rounded-lg bg-background text-text-primary"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors"
              onClick={() => setShowPassword(!showPassword)}
            >
              <Icon name={showPassword ? "EyeOff" : "Eye"} size={18} />
            </button>
          </div>
        </div>
        <Button type="submit" variant="primary" size="md" className="w-full" loading={loading}>
          Login
        </Button>
        <div className="mt-4 text-center text-sm">
          Don't have an account?{' '}
          <button type="button" className="text-primary underline" onClick={() => navigate('/signup')}>
            Sign up
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login; 